import React from "react";
import { connect } from "react-redux";
import * as catalogActions from "../../../Home/actions/catalogs";
import { MembershipSelector } from "../../components/MembershipSelector";
import find from "lodash.find";
import { Membership } from "../../../types-business/Products";

interface Props {
  getMemberships: () => any;
  getMembershipsByClub: (clubId: string) => any;
  getMembershipsTypesByClubAvailableToSell: (clubId: string) => any;
  loading: boolean;
  memberships: Membership[];
  membershipsTypesAvailableToSell: Membership[];
  extraMemberships: Membership[];
  disabled: boolean;
  onChange: (value: Membership) => any;
  value: Membership;
  clubId: string;
}

class MaintenanceSelectorContainer extends React.Component<Props> {
  componentDidMount() {
    this.loadMembership(this.props.clubId);
  }

  componentDidUpdate({ clubId: prevclubId }) {
    const { clubId } = this.props;
    if (prevclubId != clubId) {
      this.loadMembership(clubId);
    }
  }

  loadMembership = clubId => {
    if (clubId) {
      this.props.getMembershipsTypesByClubAvailableToSell(clubId);
    } else {
      this.props.getMemberships();
    }
  };

  render() {
    return (
      <MembershipSelector
        value={this.props.value}
        memberships={this.props.membershipsTypesAvailableToSell}
        extraMemberships={this.props.extraMemberships}
        onChange={value => {
          const membershipObject = find(
            this.props.membershipsTypesAvailableToSell,
            ({ datosBasicosMembresiaId }) => value == datosBasicosMembresiaId
          );
          this.props.onChange(membershipObject);
        }}
        disabled={this.props.disabled || this.props.loading}
      />
    );
  }
}

const mapDispatchToProps = dispatch => ({
  getMemberships: () => {
    dispatch(catalogActions.getMembershipsTypes());
  },
  getMembershipsByClub: (clubId: string) => {
    dispatch(catalogActions.getMembershipsTypesByClub(clubId));
  },
  getMembershipsTypesByClubAvailableToSell: (clubId: string) => {
    dispatch(catalogActions.getMembershipsTypesByClubAvailableToSell(clubId));
  }
});

const mapStateToProps = state => {
  const {
    catalogs: {
      membershipsTypes,
      membershipsTypesAvailableToSell,
      gettingMembershipsTypes
    }
  } = state;

  return {
    memberships: membershipsTypes,
    membershipsTypesAvailableToSell: membershipsTypesAvailableToSell,
    loading: gettingMembershipsTypes
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(MaintenanceSelectorContainer);
